






















import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default defineComponent({
  components: { FieldError },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = props
    const dontShowToPublic = ref(false)
    const email = ref<string | null>(null)

    function onValue(v: Ref<any>) {
      if (!v.value) {
        email.value = null
        dontShowToPublic.value = false
      } else if (typeof v.value === 'string') {
        email.value = v.value
        dontShowToPublic.value = false
      } else if (v.value.email) {
        email.value = v.value.email
        dontShowToPublic.value = v.value.dont_show_to_public
      }
    }
    const {
      error,
      debouncedValueChanged,
      valueChanged,
      isValid
    } = useClassifiedForm(props, { onValue })
    const formValidationBuilder = useDep(FormValidationBuilder)

    const allowNonPublic = computed(() => specs?.allow_non_public)
    const placeholder = computed(() => specs?.placeholder)

    const handleTextInput = (text: string) => {
      formValidationBuilder
        .new(error)
        .emailIsValid(text)
        .validate()
      debouncedValueChanged(name, {
        email: text,
        dont_show_to_public: dontShowToPublic.value
      })
    }

    const handleDontShowToPublicChange = (dontShowToPublic: boolean) => {
      valueChanged(name, {
        email: email.value,
        dont_show_to_public: dontShowToPublic
      })
    }

    return {
      dontShowToPublic,
      email,
      allowNonPublic,
      placeholder,
      error,
      isValid,
      handleTextInput,
      handleDontShowToPublicChange
    }
  }
})
